// exports PackageBundleType - an immutable object 'enum'
// usage: import { PackageBundleType  } from '../../enums/PackageBundleType';
const packageBundleType = {
    ReportPackage : 10,
    AlertPackage : 20
};
Object.freeze(packageBundleType);
export const PackageBundleType = packageBundleType;